import styled from "styled-components";

export const TimeoutImage = styled.img`
  margin-top: 40px;
  margin-bottom: 50px;
  max-height: 250px;
`;
